import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';
import { getWatchedEpisodeCount } from '../../utils/animeUtils';

const StatsCard = ({ animes }) => {
  const { t } = useLanguage();
  const totalAnimes = animes.length;
  const totalEpisodes = animes.reduce((sum, anime) => sum + (anime.episodes?.length || 0), 0);
  const watchedEpisodes = animes.reduce((sum, anime) =>
    sum + getWatchedEpisodeCount(anime), 0
  );
  const completedAnimes = animes.filter(anime => {
    const episodeCount = anime.episodes?.length || 0;
    if (episodeCount === 0) return false;
    return getWatchedEpisodeCount(anime) === episodeCount;
  }).length;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6 mb-6">
      <h2 className="text-lg font-bold text-gray-800 dark:text-gray-100 mb-4">📊 {t('statistics')}</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="text-center">
          <div className="text-2xl font-bold text-blue-600">{totalAnimes}</div>
          <div className="text-sm text-gray-600 dark:text-gray-300">{t('totalAnime')}</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-green-600">{completedAnimes}</div>
          <div className="text-sm text-gray-600 dark:text-gray-300">{t('completedAnime')}</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-purple-600">{watchedEpisodes}</div>
          <div className="text-sm text-gray-600 dark:text-gray-300">{t('totalEpisodesWatched')}</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-orange-600">
            {totalEpisodes > 0 ? Math.round((watchedEpisodes / totalEpisodes) * 100) : 0}%
          </div>
          <div className="text-sm text-gray-600 dark:text-gray-300">{t('completionRate')}</div>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
